module.exports = __webpack_public_path__ + "69eafb92077a5edcaa5243638416640c.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/war_has_a_price-320.webp
// module id = 618
// module chunks = 0